<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, useAttrs, watch } from 'vue'
import moment from 'moment'

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
  (e: 'update:subpopup', data: boolean): void
  (e: 'update:modelValue', data: Date): void
}>()
const props = withDefaults(
  defineProps<{
    modelValue?: Date
    valueFormat?: string
    maxDate?: Date
  }>(),
  {
    modelValue: () => new Date(),
    valueFormat: 'YYYY-MM-DD',
    maxDate:()=>new Date()
  }
)
const visible = ref(false)
const valueFormatter = computed(() => {
  return moment(props.modelValue).format(props.valueFormat)
})

function onConfirm({ selectedValue }: { selectedValue: string[] }) {
  emit('update:modelValue', new Date(selectedValue.join('-')))
  visible.value = false
}

function handleOpen() {
  visible.value = true
}
</script>

<template>
  <div class="date-picker">
    <div class="date-picker__content" @click="handleOpen">
      <slot :format="valueFormatter">
        <div>{{ valueFormatter }}</div>
      </slot>
    </div>

    <nut-popup
      @open="$emit('update:subpopup', true)"
      @closed="$emit('update:subpopup', false)"
      teleport-disable
      position="bottom"
      v-model:visible="visible"
    >
      <nut-date-picker
        @click.stop
        v-bind="$attrs"
        @confirm="onConfirm"
        @cancel="visible=false"
        :model-value="modelValue"
        :three-dimensional="false"
        class="date-picker__control"
        option-height="60"
        type="year-month"
        :max-date="maxDate"

      />
    </nut-popup>
  </div>
</template>

<style lang="scss">
.date-picker__control {
  --nut-picker-item-text-font-size: 0.69rem;
}
</style>
